import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@rebass/emotion';

import PageTitle from '@app/components/PageTitle';
import Link from '@app/components/Link';
import { rem } from '@app/styles/theme/layout';
import ErrorBoundary from '@app/components/ErrorBoundary';

import {
  Skeleton,
  SubHeader,
  SubHeaderTitle,
} from '@app/shop/components/Skeleton/Skeleton';
import { ShopStoreProvider } from '@app/shop/context/ShopStoreContext';
import AuthCheck from '@app/shop/components/AuthCheck';
import messages from './Response.messages';

const ResponseLayout: FC = ({ children }) => {
  return (
    <AuthCheck>
      <Skeleton>
        <PageTitle>{messages.title}</PageTitle>
        <SubHeader>
          <SubHeaderTitle>
            <Link to={`/:language/shop/checkout/response`}>
              <FormattedMessage {...messages.title} />
            </Link>
          </SubHeaderTitle>
        </SubHeader>
        <ErrorBoundary>
          <Box
            width="100%"
            maxWidth={rem(650)}
            my={[30, 40]}
            px={[20, 0]}
            mx="auto"
          >
            <ShopStoreProvider>{children}</ShopStoreProvider>
          </Box>
        </ErrorBoundary>
      </Skeleton>
    </AuthCheck>
  );
};

export default ResponseLayout;
